import affairs from "./affairs.json";
import explore from "./explore-more.json"
import polity from "./polity.json"
import economics from "./economics.json";
import history from "./history.json";
import geography from "./geography.json";
import physics from "./physics.json";
import chemistry from "./chemistry.json";
import biology from "./biology.json";
import english from "./english.json";
import staticgk from "./staticgk.json";

const allData = [
    staticgk, geography, history, biology, polity, english, economics, physics, chemistry, affairs, explore,
]

export default allData;
